export const SET_IS_COMPONENT_OUVRIR_MAIL = 'SET_IS_COMPONENT_OUVRIR_MAIL';
export const SET_IS_COMPONENT_ENREGISTRER_OPPORTUNITE_ACTIVE = 'SET_IS_COMPONENT_ENREGISTRER_OPPORTUNITE_ACTIVE';
export const SET_IS_COMPONENT_CONFIRMATION_MAIL = 'SET_IS_COMPONENT_CONFIRMATION_MAIL';
export const SET_IS_COMPONENT_AJOUT_CLIENT = 'SET_IS_COMPONENT_AJOUT_CLIENT';
export const SET_IS_COMPONENT_DIAPORAMA = 'SET_IS_COMPONENT_DIAPORAMA';
export const SET_FACES_SELECT_DIAPO = 'SET_FACES_SELECT_DIAPO';



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/modal-mutation-type.js